import Appointment2 from '@/components/Appointment2/index.vue';
import Banner from '@/components/Banner2';
import Features from '@/components/Features';
import { FEATURES_LIST, SKILL_LIST } from './index.js';
import Skill from '@/components/Skill';
import Cases from './components/Cases';
import Function from './components/Function';
export default {
  components: {
    Banner,
    Features,
    Function,
    Skill,
    Cases,
    Appointment2
  },
  data() {
    return {
      featuresList: FEATURES_LIST,
      skillList: SKILL_LIST,
      productId: this.$productId.PC_KE_HU_DUAN.PC_MAC_BAN
    };
  }
};